// /src/Redux/WhatsNew/whatsNewSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosWithAuth from '../../UtilsRedux/axiosWithAuth';
import { API_ROUTES } from '../../Constants/apiRoutes';
import axios from '../../UtilsRedux/axiosWithAuth'; // same instance
import { showFeedback } from '../../UI/uiFeedbackSlice';

export const fetchWhatsNew = createAsyncThunk(
  'whatsNew/fetchPublic',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await axios.get(API_ROUTES.WHATS_NEW_PUBLIC);
      return res.data.data; // { released: [], coming: [] }
    } catch (e) {
      const message =
        e?.response?.data?.message || 'Failed to load What’s New';

      // 🔸 soft warning, not full-blown “error”
      dispatch(
        showFeedback({
          type: 'warning',
          title: 'Unable to load updates',
          message,
        })
      );

      return rejectWithValue(message);
    }
  }
);

// optional admin actions for later
export const createWhatsNewItem = createAsyncThunk(
  'whatsNew/create',
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await axiosWithAuth.post(API_ROUTES.WHATS_NEW_ADMIN, payload);
      const item = res.data.data;

      // ✅ success popup for admin
      dispatch(
        showFeedback({
          type: 'success',
          title: 'Release note added',
          message: 'Your update has been added to What’s New.',
        })
      );

      return item;
    } catch (e) {
      const message = e?.response?.data?.message || 'Failed to create update';

      dispatch(
        showFeedback({
          type: 'error',
          title: 'Create failed',
          message,
        })
      );

      return rejectWithValue(message);
    }
  }
);

const slice = createSlice({
  name: 'whatsNew',
  initialState: {
    released: [],
    coming: [],
    status: 'idle',
    error: null,
    lastLoadedAt: null,
  },
  reducers: {
    resetWhatsNew: (s) => {
      s.released = [];
      s.coming = [];
      s.status = 'idle';
      s.error = null;
      s.lastLoadedAt = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchWhatsNew.pending, (s) => {
      s.status = 'loading';
    })
      .addCase(fetchWhatsNew.fulfilled, (s, a) => {
        s.released = a.payload.released || [];
        s.coming = a.payload.coming || [];
        s.status = 'succeeded';
        s.lastLoadedAt = Date.now();
      })
      .addCase(fetchWhatsNew.rejected, (s, a) => {
        s.status = 'failed';
        s.error = a.payload;
      })
      .addCase(createWhatsNewItem.fulfilled, (s, a) => {
        const item = a.payload;
        if (item.type === 'released') s.released.unshift(item);
        else s.coming.unshift(item);
      });
  },
});

export const { resetWhatsNew } = slice.actions;
export default slice.reducer;
